import { ROUTE } from "../../../routes";
export const goBack = async (action, _datastore, { goBack }) => {
    await goBack();
};
export const navigateToFaq = async (action, _datastore, { navigate, instrumentTrack }) => {
    const data = action?.payload?.item;
    const title = action?.payload?.title;
    await instrumentTrack('HELP_AND_SUPPORT_CATEGORY_SELECTED', {
        category: title,
    });
    await navigate(ROUTE.FAQ_SCREEN, { data, title });
};
